enum StoreActions {
  IS_LOADER_SHOW = 'BOOKINGS/IS_LOADER_SHOW',
  IS_LOADER_HIDE = 'BOOKINGS/IS_LOADER_HIDE',
  SAVE_BOOKINGS = 'BOOKINGS/SAVE_BOOKINGS',
  FILTER_BOOKINGS = 'BOOKINGS/FILTER_BOOKINGS',
  CHANGE_FILTER = 'BOOKINGS/CHANGE_FILTER',
  INCREASE_FILTER_OFFSET = 'BOOKINGS/INCREASE_FILTER_OFFSET',
  RESET = 'BOOKINGS/RESET',
  SAVE_PICK_UP_PARKINGS = 'BOOKINGS/SAVE_PICK_UP_PARKINGS',
  SET_SELECTED_PICK_UP_PARKING = 'BOOKINGS/SET_SELECTED_PICK_UP_PARKING',
  SET_SELECTED_TRAILER_TYPE_ID = 'BOOKINGS/SET_SELECTED_TRAILER_TYPE_ID',
  SET_CURRENT_BOOKING = 'BOOKINGS/SET_CURRENT_BOOKING',
}

enum SagaEvents {
  LOAD_PAGE = 'BOOKINGS/LOAD_PAGE',
  GET_BOOKINGS = 'BOOKINGS/GET_BOOKINGS',
  GET_BOOKINGS_XLSX = 'BOOKINGS/GET_BOOKINGS_XLSX',
  GET_PICK_UP_PARKINGS = 'BOOKINGS/GET_PICK_UP_PARKINGS',
  GET_BOOKING_DETAILS = 'BOOKINGS/GET_BOOKING_DETAILS',
  CANCEL_BOOKING = 'BOOKINGS/CANCEL_BOOKING',
}

export const ActionTypes_Bookings = {
  SagaEvents,
  StoreActions,
}
